module.exports = __webpack_public_path__ + "img/kangwonland-login.20ca3525.svg";